const VERSION = `2026.6.3`

export const appVersion = () => {
  return VERSION
}
